import { all, call, cancelled, put, takeLatest } from "redux-saga/effects";
import LearningObjectService from "../../services/LearningObjectService";

import {
  listSuccess,
  listFail,
  createSuccess,
  createFail,
  detailsSuccess,
  detailsFail,
  updateDetailSuccess,
  updateDetailFail,
} from "../slices/learningObjectsSlice";

function* list(data) {
  try {
    const ajax = yield call(LearningObjectService.list, data.payload);
    if (ajax.status === 200) {
      yield put(listSuccess(ajax.data));
    } else {
      yield put(
        listFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      listFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* create(data) {
  try {
    const ajax = yield call(LearningObjectService.create, data.payload);
    if (ajax.status === 200) {
      yield put(createSuccess(ajax.data));
    } else {
      yield put(
        createFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      createFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* details(data) {
  try {
    const ajax = yield call(LearningObjectService.details, data.payload);
    if (ajax.status === 200) {
      yield put(detailsSuccess(ajax.data));
    } else {
      yield put(
        detailsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      detailsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}
function* update(data) {
  try {
    const ajax = yield call(LearningObjectService.update, data.payload);
    if (ajax.status === 200) {
      yield put(updateDetailSuccess(ajax.data));
    } else {
      yield put(
        updateDetailFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateDetailFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

export default function* learningObjectSaga() {
  yield all([
    takeLatest("learningObjects/listRequest", list),
    takeLatest("learningObjects/createRequest", create),
    takeLatest("learningObjects/detailsRequest", details),
    takeLatest("learningObjects/updateDetailRequest", update),
  ]);
}
